import { getObjectUtil } from 'packages/src'

function getValueReduxUtil (instance, key) {
  if (!instance) {
    return
  }

  const changedValue = getObjectUtil(instance, `changed.${key}`)
  if (typeof changedValue !== 'undefined') {
    return changedValue
  }

  const dataValue = getObjectUtil(instance, `data.${key}`)
  if (typeof dataValue !== 'undefined') {
    return dataValue
  }

  return getObjectUtil(instance, key)
}

export default getValueReduxUtil
